import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat'
})
export class NumberFormatPipe implements PipeTransform {
  transform(value: number): string {
    if (isNaN(value)) {
      return value.toString();
    }

    return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(value);
  }
}
